import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./Partners.css";

const Partners = (props) => {
  const [partners, setPartners] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredPartners, setFilteredPartners] = useState([]);

  let { currentLanguage } = props;
  const { partnersTitle, searchPlaceholder } = currentLanguage.text;

  useEffect(() => {
    const fetchVendorList = async () => {
      try {
        const response = await fetch(
          "https://nojazz.eu/consent/cmpv3/vendor-list.json"
        );
        const data = await response.json();

        const vendors = data.vendors ? Object.values(data.vendors) : [];
        setPartners(vendors);
      } catch (error) {
        console.error("Error fetching vendor list:", error);
      }
    };
    fetchVendorList();
  }, []);

  const handleSearch = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);
    const filteredPartners = partners.filter((partner) =>
      partner.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredPartners(filteredPartners);
  };

  const partnersList = searchTerm ? filteredPartners : partners;

  return (
    <div className="partners-container">
      <h2 className="partners-title">{partnersTitle || "Partners"}</h2>
      <input
        type="text"
        placeholder={searchPlaceholder || "Search partners"}
        value={searchTerm}
        onChange={handleSearch}
      />
      <ul className="partners-list">
        {partnersList.map((partner) => (
          <li key={partner.id} className="partners-item">
            {partner.name}
          </li>
        ))}
      </ul>
    </div>
  );
};
const mapStateToProps = (state) => {
  return { ...state, currentLanguage: state.currentLanguage };
};

export default connect(mapStateToProps)(Partners);
